import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import HowItWorksSection from './components/HowItWorksSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import SafetySection from './components/SafetySection';
import BlogCTASection from './components/BlogCTASection';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <WhatIsSection />
        <HowItWorksSection />
        <ArticleCardsSection />
        <SafetySection />
        <BlogCTASection />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}